const styles = theme => ({
  root: {
    width: '100%',
  },
  formControl: {
    width: '100%',
  },
  formControlHalf: {
    margin: theme.spacing(1),
    width: '50%',
  },
  select: {
    width: '98%',
    minHeight: '40px',
    '& .MuiSelect-selectMenu': {
      whiteSpace: 'unset',
    },
  },
  infoTextForGroup: {
    marginTop: '8px',
  },
  displayFAI: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
})

export default styles
